APP.Datepicker = (/** @lends APP.Datepicker */function () {
	'use strict';

	var exports = {},
		activeDatepickers = [],
		resizeTid = 0,
		$body;

	function init() {
		rangeInit();
		initLang();
		initDOMElements();
		initBindings();
		initRangedDatepicker();
	}

	function initLang() {
		$.datepicker.regional.hu = {
			closeText: 'bezár',
			prevText: 'vissza',
			nextText: 'előre',
			currentText: 'ma',
			monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
			monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
			dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
			dayNamesShort: ['Vas', 'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo'],
			dayNamesMin: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
			weekHeader: 'Hét',
			dateFormat: 'yy.mm.dd.',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: true,
			yearSuffix: ''
		};

		$.datepicker.setDefaults($.datepicker.regional.hu);
	}

	function rangeInit() {
		var datepickerUpdateDatepicker = $.datepicker._updateDatepicker;

		$.datepicker._defaults.onAfterUpdate = null;

		$.datepicker._updateDatepicker = function (inst) {
			var onAfterUpdate = this._get(inst, 'onAfterUpdate');

			datepickerUpdateDatepicker.call(this, inst);

			if (onAfterUpdate) {
				onAfterUpdate.apply(inst.input ? inst.input[0] : null,
					[inst.input ? inst.input.val() : '', inst]);
			}
		};

	}

	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
	}

	function initBindings() {
		$(window).on({
			resize: function () {
				window.clearTimeout(resizeTid);
				resizeTid = window.setTimeout(function () {
					var i, l = activeDatepickers.length;

					for (i = 0; i < l; i++) {
						setNumberOfMonths(activeDatepickers[i]);
					}

				}, 300);
			}
		});
	}

	function setNumberOfMonths($picker) {
		var numberOfMonths = $(window).width() < 769 ? 1 : 2;

		$picker.datepicker('option', 'numberOfMonths', numberOfMonths);
		$picker.datepicker('refresh');
	}

	function initRangedDatepicker() {
		$body.find('[data-datepicker="ranged"] .datepicker__target').each(function () {
			initDatePicker($(this));
		});
	}

	function initDatePicker($elem) {
		var $wrapper = $elem.parent(),
			$input = $wrapper.find('input');

		if ($elem.data('datePickerIndex') === undefined) {
			$elem.data({datePickerIndex: {cur: -1, prv: -1}});
		}

		$elem.datepicker({
			maxDate: 0,
			dateFormat: 'yy.mm.dd',
			numberOfMonths: $(window).width() < 769 ? 1 : 2,
			changeMonth: false,
			changeYear: false,
			showButtonPanel: true,
			showOtherMonths: true,
			beforeShowDay: function (date) {
				var prv, cur;

				prv = $elem.data('datePickerIndex').prv;
				cur = $elem.data('datePickerIndex').cur;

				return [true, date.getTime() >= Math.min(prv, cur) && date.getTime() <= Math.max(prv, cur) ? 'date-range-selected' : ''];
			},
			onSelect: function (dateText, inst) {
				var d1, d2,
					cur, prv;

				cur = $elem.data('datePickerIndex').cur;

				prv = cur;
				cur = (new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay)).getTime();

				if (prv === -1 || prv === cur) {
					prv = cur;
					$input.val(dateText);
				} else {
					d1 = $.datepicker.formatDate('yy.mm.dd', new Date(Math.min(prv, cur)), {});
					d2 = $.datepicker.formatDate('yy.mm.dd', new Date(Math.max(prv, cur)), {});

					$input.val(d1 + ' - ' + d2);
				}

				$elem.data({datePickerIndex: {cur: cur, prv: prv}});

			},
			onAfterUpdate: function () {
				var $button = $('<button type="button" class="button button--outlined button--small" data-save-date data-handler="hide" data-event="click">Mentés</button>');

				$elem.find('.ui-datepicker-buttonpane button[data-handler="today"]').remove();
				if ($elem.find('.ui-datepicker-buttonpane [data-save-date]').length < 1) {
					$button.appendTo($elem.find('.ui-datepicker-buttonpane'));
					$button.on({
						click: function () {
							$elem.datepicker().hide();
							$input.trigger('change');
						}
					});
				}
			}
		}).position({
			my: 'left top',
			at: 'left bottom',
			of: $input
		});

		$elem.datepicker().hide();

		$input.on('focus', function () {
			var v = this.value;

			setDate($elem, v);
			$elem.parents('.datepicker').addClass('datepicker--active');
			activeDatepickers.push($elem.datepicker());
			setNumberOfMonths($elem);
			$elem.datepicker().show();
		});

		$elem.parents('[data-datepicker]').find('[data-datepicker-trigger]').on({
			click: function (e) {
				var v = $elem.parents('.datepicker').find('input')[0].value;

				e.preventDefault();

				setDate($elem, v);
				$elem.parents('.datepicker').addClass('datepicker--active');
				activeDatepickers.push($elem.datepicker());
				setNumberOfMonths($elem);
				$elem.datepicker().show();
			}
		});

		$body.on({
			click: function (e) {
				var $target = $(e.target);

				if ($target.parents('[data-datepicker]').length < 1 && $target.attr('class') && $target.attr('class').match(/datepicker/ig) === null) {

					while (activeDatepickers.length) {
						$(activeDatepickers[activeDatepickers.length - 1]).parents('.datepicker').removeClass('datepicker--active');
						$(activeDatepickers[activeDatepickers.length - 1]).parents('.datepicker').find('input').trigger('change');
						activeDatepickers[activeDatepickers.length - 1].hide();
						activeDatepickers.pop();
					}

				}

			}
		});

	}

	function setDate($elem, v) {
		var prv, cur, d;

		try {
			if (v.indexOf(' - ') > -1) {
				d = v.split(' - ');
				prv = $.datepicker.parseDate('yy.mm.dd', d[0]).getTime();
				cur = $.datepicker.parseDate('yy.mm.dd', d[1]).getTime();
			} else if (v.length > 0) {
				prv = cur = $.datepicker.parseDate('yy.mm.dd', v).getTime();
			}
		} catch (e) {
			cur = prv = -1;
		}

		if (cur > -1) {
			$elem.datepicker('setDate', new Date(cur));
		}

		$elem.data({datePickerIndex: {cur: cur, prv: prv}});

		return {cur: cur, prv: prv};
	}

	exports.init = init;

	return exports;

}());
